import { getRequest, postRequest, patchRequest, deleteRequest } from './api';

const brandsApi = {
  async getBrands() {
    const response = await getRequest('/brands');
    return response;
  },

  async setActiveBrand(brandId) {
    const response = await patchRequest('/user/active-brand', { brand_id: brandId });
    return response;
  },

  async scrapeWebsite(url) {
    const response = await postRequest('/brands/scrape-website', { url });
    return response;
  },

  async createBrand(brandData) {
    const response = await postRequest('/brands', brandData);
    return response;
  },

  async updateBrand(brandId, brandData) {
    const payload = typeof brandData === 'string'
      ? { name: brandData }
      : brandData;
    const response = await patchRequest(`/brands/${brandId}`, payload);
    return response;
  },

  async deleteBrand(brandId) {
    const response = await deleteRequest(`/brands/${brandId}`);
    return response;
  },
};

export default brandsApi;

